import { render, staticRenderFns } from "./header-auth.vue?vue&type=template&id=00a48cff"
import script from "./header-auth.vue?vue&type=script&lang=js"
export * from "./header-auth.vue?vue&type=script&lang=js"
import style0 from "./header-auth.vue?vue&type=style&index=0&id=00a48cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports